import { render, staticRenderFns } from "./Expedicao.vue?vue&type=template&id=c036036c"
import script from "./Expedicao.vue?vue&type=script&lang=js"
export * from "./Expedicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports